<template>
  <div>
    <div class="card p-4 shadow-sm">
      <!-- Toast -->
      <div v-if="mostrarToast" class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1055">
        <div class="toast show align-items-center text-white" :class="toastColor">
          <div class="d-flex">
            <div class="toast-body"><i :class="iconoToast" class="me-2"></i>{{ alerta.mensaje }}</div>
            <button type="button" class="btn-close btn-close-white me-2 m-auto" @click="cerrarToast"></button>
          </div>
        </div>
      </div>

      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center mb-4">
        <h3 class="m-0">Caja Chica Hotel</h3>
        <h5>Saldo de Caja Chica: Q{{ totalCaja.toFixed(2) }}</h5>
      </div>

      <!-- Botón agregar gasto -->
      <div v-if="!mostrarFormularioGasto" class="mb-4">
        <button class="btn btn-success" @click="mostrarFormularioGasto = true">
          <i class="bi bi-plus-circle me-1"></i> Agregar Gasto
        </button>
      </div>

      <!-- Formulario registrar gasto -->
      <form v-if="mostrarFormularioGasto" @submit.prevent="registrarGasto" class="row g-3 border p-3 rounded mb-4">
        <div class="col-md-2">
          <input v-model.number="form.Monto" type="number" step="0.01" min="0.01" class="form-control" placeholder="Monto *" required />
        </div>
        <div class="col-md-2">
          <input v-model="form.Motivo" type="text" class="form-control" placeholder="Motivo *" required />
        </div>
        <div class="col-md-2">
          <select v-model="form.Tipo" class="form-select" required>
            <option value="" disabled>Tipo *</option>
            <option value="hotel">Hotel</option>
            <option value="restaurante">Restaurante</option>
            <option value="gastos_generales">Gastos Generales</option>
          </select>
        </div>
        <div class="col-md-2">
          <input v-model="form.NumeroFactura" type="text" class="form-control" placeholder="Factura/Recibo" />
        </div>
        <div class="col-md-2">
          <input v-model="form.Observaciones" type="text" class="form-control" placeholder="Observaciones" />
        </div>
        <div class="col-md-2">
          <input v-model="form.Autorizado" type="text" class="form-control" placeholder="Autorizado por" />
        </div>
        <div class="col-12 text-end">
          <button type="button" class="btn btn-secondary me-2" @click="cancelarFormularioGasto">Cancelar</button>
          <button type="submit" class="btn btn-primary">Guardar</button>
        </div>
      </form>

      <!-- Actualizar total (solo Admin) -->
      <div v-if="rolUsuario === 1" class="row g-3 border p-3 rounded mb-4">
        <div class="col-md-6">
          <input v-model.number="nuevoMontoCaja" type="number" step="0.01" min="0.01" class="form-control" placeholder="Agregar monto a caja chica" />
        </div>
        <div class="col-md-6 text-end">
          <button class="btn btn-primary" @click="mostrarModal = true" :disabled="!nuevoMontoCaja">Agregar Monto</button>
        </div>
        <div class="text-end mt-4">
          <button class="btn btn-outline-secondary" @click="abrirModalLogs">
            <i class="bi bi-clock-history me-1"></i> Ver acciones recientes
          </button>
        </div>
      </div>

      <!-- Modal confirmación de total -->
      <div v-if="mostrarModal" class="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 d-flex align-items-center justify-content-center" style="z-index: 1056">
        <div class="bg-white p-4 rounded shadow" style="min-width: 300px">
          <h5 class="mb-3">Confirmar Actualización</h5>
          <p>¿Está seguro de que desea agregar Q{{ nuevoMontoCaja?.toFixed(2) }}?</p>
          <div class="d-flex justify-content-end gap-2">
            <button class="btn btn-secondary" @click="cerrarModal">Cancelar</button>
            <button class="btn btn-primary" @click="confirmarActualizarTotal">Sí, actualizar</button>
          </div>
        </div>
      </div>

      <!-- Modal editar gasto -->
      <div v-if="mostrarModalEditar" class="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 d-flex align-items-center justify-content-center" style="z-index: 1057">
        <div class="bg-white p-4 rounded shadow w-100" style="max-width: 800px">
          <h5 class="mb-3">Editar Gasto</h5>
          <div class="row g-3">
            <div class="col-12 col-md-2">
              <label class="form-label">Monto</label>
              <input v-model.number="form.Monto" type="number" step="0.01" min="0.01" class="form-control" />
            </div>
            <div class="col-12 col-md-2">
              <label class="form-label">Motivo</label>
              <input v-model="form.Motivo" type="text" class="form-control" />
            </div>
            <div class="col-12 col-md-2">
              <label class="form-label">Tipo</label>
              <select v-model="form.Tipo" class="form-select">
                <option value="hotel">Hotel</option>
                <option value="restaurante">Restaurante</option>
                <option value="gastos_generales">Gastos Generales</option>
              </select>
            </div>
            <div class="col-12 col-md-2">
              <label class="form-label">Factura</label>
              <input v-model="form.NumeroFactura" type="text" class="form-control" />
            </div>
            <div class="col-12 col-md-2">
              <label class="form-label">Observaciones</label>
              <input v-model="form.Observaciones" type="text" class="form-control" />
            </div>
            <div class="col-12 col-md-2">
              <label class="form-label">Autorizado por</label>
              <input v-model="form.Autorizado" type="text" class="form-control" />
            </div>
            <div class="col-12 text-end mt-3">
              <button class="btn btn-secondary me-2" @click="cerrarModalEditar">Cancelar</button>
              <button class="btn btn-primary" @click="actualizarGasto">Actualizar</button>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal confirmación devolución -->
      <div v-if="mostrarModalDevolver" class="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 d-flex align-items-center justify-content-center" style="z-index: 1058">
        <div class="bg-white p-4 rounded shadow" style="min-width: 340px">
          <h5 class="mb-3">Confirmar Devolución</h5>
          <p>¿Devolver <strong>Q{{ gastoPorDevolver?.Monto?.toFixed(2) }}</strong> a caja chica?<br><small class="text-muted">{{ gastoPorDevolver?.Motivo }}</small></p>
          <p class="text-danger small">Esta acción suma el monto al saldo de caja chica y marca el gasto como devuelto.</p>
          <div class="d-flex justify-content-end gap-2">
            <button class="btn btn-secondary" @click="mostrarModalDevolver = false">Cancelar</button>
            <button class="btn btn-success" @click="confirmarDevolucion" :disabled="devolviendo">
              <span v-if="devolviendo" class="spinner-border spinner-border-sm me-1"></span>
              Confirmar
            </button>
          </div>
        </div>
      </div>

      <!-- Filtros y PDF -->
      <div class="row g-3 border p-3 rounded mb-4 align-items-end">
        <div class="col-md-2">
          <label class="form-label small text-muted mb-1">Fecha inicio</label>
          <input type="date" v-model="pdfInicio" class="form-control" />
        </div>
        <div class="col-md-2">
          <label class="form-label small text-muted mb-1">Fecha fin</label>
          <input type="date" v-model="pdfFin" class="form-control" />
        </div>
        <div class="col-md-2">
          <label class="form-label small text-muted mb-1">Tipo</label>
          <select v-model="filtroTipo" class="form-select">
            <option value="">Todos</option>
            <option value="hotel">Hotel</option>
            <option value="restaurante">Restaurante</option>
            <option value="gastos_generales">Gastos Generales</option>
          </select>
        </div>
        <div class="col-md-2">
          <label class="form-label small text-muted mb-1">Factura</label>
          <select v-model="filtroFactura" class="form-select">
            <option value="">Todos</option>
            <option value="con_factura">Con Factura</option>
            <option value="recibo">Recibo / Sin Factura</option>
          </select>
        </div>
        <div class="col-md-2">
          <button class="btn btn-outline-primary w-100" @click="cargarRegistros">
            <i class="bi bi-search me-1"></i> Filtrar
          </button>
        </div>
        <div class="col-md-2">
          <button class="btn btn-danger w-100" @click="generarPDF" :disabled="!pdfInicio || !pdfFin">
            <i class="bi bi-file-earmark-pdf"></i> Generar PDF
          </button>
        </div>
        <div class="col-12 text-end" v-if="pdfInicio || pdfFin || filtroTipo || filtroFactura">
          <button class="btn btn-link btn-sm p-0 text-muted" @click="limpiarFiltro">
            <i class="bi bi-x-circle me-1"></i> Limpiar filtros
          </button>
        </div>
      </div>

      <!-- Tabla -->
      <div class="table-responsive">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h5 class="m-0">Historial de Registros</h5>
          <div class="badge bg-primary fs-6">
            Total filtrado (activos): Q{{ totalFiltrado.toFixed(2) }}
          </div>
        </div>
        <table class="table table-bordered text-center align-middle">
          <thead class="table-light">
            <tr>
              <th>#</th>
              <th>Fecha</th>
              <th>Monto</th>
              <th>Tipo</th>
              <th>Motivo</th>
              <th>Factura</th>
              <th>Observaciones</th>
              <th>Empleado</th>
              <th>Autorizado por</th>
              <th>Estado</th>
              <th>Acción</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="registros.length === 0">
              <td colspan="11">No hay registros.</td>
            </tr>
            <tr v-for="r in registros" :key="r.IdCajaChica" :class="{ 'table-secondary': r.Devuelto }">
              <td>{{ r.IdCajaChica }}</td>
              <td>{{ r.Fecha }}</td>
              <td>Q{{ Number(r.Monto ?? 0).toFixed(2) }}</td>
              <td><span class="badge" :class="tipoBadgeClass(r.Tipo)">{{ tipoLabel(r.Tipo) }}</span></td>
              <td>{{ r.Motivo }}</td>
              <td>{{ r.NumeroFactura || '-' }}</td>
              <td>{{ r.Observaciones || '-' }}</td>
              <td>{{ r.empleado?.Nombres }} {{ r.empleado?.Apellidos }}</td>
              <td>{{ r.Autorizado || '-' }}</td>
              <td>
                <span v-if="r.Devuelto" class="badge bg-info text-dark">Devuelto</span>
                <span v-else class="badge bg-success">Activo</span>
              </td>
              <td class="d-flex gap-1 justify-content-center">
                <button class="btn btn-sm btn-warning" @click="cargarEdicion(r)" :disabled="!!r.Devuelto">
                  <i class="bi bi-pencil me-1"></i> Editar
                </button>
                <button v-if="rolUsuario === 1 && !r.Devuelto" class="btn btn-sm btn-outline-success" @click="abrirDevolver(r)">
                  <i class="bi bi-arrow-counterclockwise me-1"></i> Devolver
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Modal logs -->
    <div v-if="mostrarModalLogs" class="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 d-flex align-items-center justify-content-center" style="z-index: 1060">
      <div class="bg-white p-4 rounded shadow w-75" style="max-height: 80vh; overflow-y: auto">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h5 class="m-0">Acciones recientes</h5>
          <button class="btn-close" @click="cerrarModalLogs"></button>
        </div>
        <table class="table table-sm table-bordered">
          <thead class="table-light">
            <tr>
              <th style="width: 200px">Fecha</th>
              <th>Descripción</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="logs.length === 0">
              <td colspan="2">No hay logs registrados.</td>
            </tr>
            <tr v-for="log in logs" :key="log.IdLogsCajaChica">
              <td>{{ formatearFecha(log.Fecha) }}</td>
              <td>{{ log.Log }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { API_URL } from '@/config/config';
import store from '@/store';

export default {
  name: 'CajaChica',
  data() {
    return {
      form: { Monto: null, Motivo: '', NumeroFactura: '', Observaciones: '', Autorizado: '', Tipo: 'hotel' },
      filtroTipo:    '',
      filtroFactura: '',
      editarId:      null,
      mostrarFormularioGasto: false,
      mostrarModal:         false,
      mostrarModalEditar:   false,
      mostrarModalDevolver: false,
      mostrarModalLogs:     false,
      devolviendo:      false,
      registros:        [],
      totalFiltrado:    0,
      totalCaja:        0,
      nuevoMontoCaja:   null,
      pdfInicio:        '',
      pdfFin:           '',
      gastoPorDevolver: null,
      mostrarToast:     false,
      alerta:           { mensaje: '', tipo: 'success' },
      logs:             [],
    };
  },
  computed: {
    empleadoId() { return store.getters.getUser?.IdEmpleado || null; },
    rolUsuario()  { return store.getters.getUser?.IdRol     || null; },
    toastColor()  { return this.alerta.tipo === 'success' ? 'bg-success' : 'bg-danger'; },
    iconoToast()  { return this.alerta.tipo === 'success' ? 'bi bi-check-circle' : 'bi bi-exclamation-circle'; },
  },
  methods: {
    cerrarToast() { this.mostrarToast = false; },
    mostrarAlerta(mensaje, tipo = 'success') {
      this.alerta = { mensaje, tipo };
      this.mostrarToast = true;
      setTimeout(this.cerrarToast, 3000);
    },
    cancelarFormularioGasto() {
      this.form = { Monto: null, Motivo: '', NumeroFactura: '', Observaciones: '', Autorizado: '', Tipo: 'hotel' };
      this.mostrarFormularioGasto = false;
    },
    cerrarModal()       { this.mostrarModal = false; },
    cerrarModalEditar() { this.mostrarModalEditar = false; this.resetFormulario(); },
    resetFormulario()   {
      this.form = { Monto: null, Motivo: '', NumeroFactura: '', Observaciones: '', Autorizado: '', Tipo: 'hotel' };
      this.editarId = null;
    },
    async cargarRegistros() {
      const params = {};
      if (this.pdfInicio && this.pdfFin) { params.fecha_inicio = this.pdfInicio; params.fecha_fin = this.pdfFin; }
      if (this.filtroTipo)    params.tipo    = this.filtroTipo;
      if (this.filtroFactura) params.factura = this.filtroFactura;
      const { data } = await axios.get(`${API_URL}/caja-chica`, { params });
      if (data && !Array.isArray(data) && Array.isArray(data.data)) {
        this.registros     = data.data;
        this.totalFiltrado = Number(data.total_filtrado || 0);
      } else {
        this.registros     = Array.isArray(data) ? data : [];
        this.totalFiltrado = this.registros.filter(r => !r.Devuelto).reduce((s, r) => s + Number(r.Monto || 0), 0);
      }
    },
    async cargarTotalCaja() {
      try {
        const { data } = await axios.get(`${API_URL}/total-caja-chica`);
        this.totalCaja = Number(data.MontoActual);
      } catch {
        this.totalCaja = 0;
        this.mostrarAlerta('Error al cargar total', 'danger');
      }
    },
    async registrarGasto() {
      try {
        const payload = { ...this.form, IdEmpleado: this.empleadoId };
        const { data } = await axios.post(`${API_URL}/caja-chica/crear`, payload);
        this.mostrarAlerta(data.mensaje, 'success');
        this.cargarRegistros();
        this.cargarTotalCaja();
        this.cancelarFormularioGasto();
      } catch (e) {
        this.mostrarAlerta(e.response?.data?.error || 'Error al registrar gasto', 'danger');
      }
    },
    async actualizarGasto() {
      try {
        const { data } = await axios.put(`${API_URL}/caja-chica/${this.editarId}/editar-recepcionista`, this.form);
        this.mostrarAlerta(data.mensaje, 'success');
        this.cargarRegistros();
        this.cargarTotalCaja();
        this.cerrarModalEditar();
      } catch (e) {
        this.mostrarAlerta(e.response?.data?.error || 'Error al actualizar gasto', 'danger');
      }
    },
    limpiarFiltro() {
      this.pdfInicio = ''; this.pdfFin = ''; this.filtroTipo = ''; this.filtroFactura = '';
      this.cargarRegistros();
    },
    async abrirModalLogs() { this.mostrarModalLogs = true; await this.cargarLogs(); },
    cerrarModalLogs()      { this.mostrarModalLogs = false; },
    async cargarLogs() {
      try {
        const { data } = await axios.get(`${API_URL}/caja-chica/logs`);
        this.logs = data;
      } catch {
        this.logs = [];
        this.mostrarAlerta('Error al cargar historial de acciones', 'danger');
      }
    },
    cargarEdicion(r) {
      this.editarId = r.IdCajaChica;
      this.form = { Monto: r.Monto, Motivo: r.Motivo, NumeroFactura: r.NumeroFactura, Observaciones: r.Observaciones, Autorizado: r.Autorizado, Tipo: r.Tipo || 'hotel' };
      this.mostrarModalEditar = true;
    },
    abrirDevolver(r) {
      this.gastoPorDevolver   = r;
      this.mostrarModalDevolver = true;
    },
    async confirmarDevolucion() {
      if (!this.gastoPorDevolver) return;
      this.devolviendo = true;
      try {
        const { data } = await axios.post(`${API_URL}/caja-chica/${this.gastoPorDevolver.IdCajaChica}/devolver`);
        this.mostrarAlerta(data.mensaje, 'success');
        this.mostrarModalDevolver = false;
        this.gastoPorDevolver = null;
        await this.cargarRegistros();
        await this.cargarTotalCaja();
      } catch (e) {
        this.mostrarAlerta(e.response?.data?.error || 'Error al devolver gasto', 'danger');
      } finally {
        this.devolviendo = false;
      }
    },
    async confirmarActualizarTotal() {
      try {
        const { data } = await axios.put(`${API_URL}/caja-chica/actualizar-total`, { MontoActual: this.nuevoMontoCaja, IdEmpleado: this.empleadoId });
        this.mostrarAlerta(data.mensaje, 'success');
        this.cargarTotalCaja();
        this.nuevoMontoCaja = null;
      } catch {
        this.mostrarAlerta('Error al actualizar total', 'danger');
      }
      this.cerrarModal();
    },
    tipoLabel(tipo) {
      const labels = { hotel: 'Hotel', restaurante: 'Restaurante', gastos_generales: 'Gastos Grls.' };
      return labels[tipo] || tipo || '-';
    },
    tipoBadgeClass(tipo) {
      const classes = { hotel: 'bg-primary', restaurante: 'bg-warning text-dark', gastos_generales: 'bg-secondary' };
      return classes[tipo] || 'bg-light text-dark';
    },
    async generarPDF() {
      try {
        const payload = { fecha_inicio: this.pdfInicio, fecha_fin: this.pdfFin };
        if (this.filtroTipo)    payload.tipo    = this.filtroTipo;
        if (this.filtroFactura) payload.factura = this.filtroFactura;
        const response = await axios.post(`${API_URL}/caja-chica/pdf`, payload, { responseType: 'blob' });
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href  = window.URL.createObjectURL(blob);
        link.download = `caja-chica_${this.pdfInicio}_${this.pdfFin}.pdf`;
        link.click();
        window.URL.revokeObjectURL(link.href);
      } catch (e) {
        if (e.response?.data instanceof Blob) {
          const text = await e.response.data.text();
          try { const json = JSON.parse(text); this.mostrarAlerta(json.error || json.message || 'Error al generar PDF', 'danger'); }
          catch { this.mostrarAlerta('Error al generar PDF', 'danger'); }
        } else {
          this.mostrarAlerta(e.response?.data?.error || 'Error al generar PDF', 'danger');
        }
      }
    },
    formatearFecha(fecha) { return new Date(fecha).toLocaleString('es-GT'); },
  },
  mounted() {
    this.cargarRegistros();
    this.cargarTotalCaja();
  },
};
</script>
